import axios from "axios";
import { API_BASE_URL, FETCH_LIMIT } from "./../../globalVars";

export default {
  namespaced: true,

  actions: {
    async hydrate({ commit }) {
      const store = this;
      const last = this.getters["entities/settings/query"]().first()
        .lastUpdateFromServer;
      await fetchNext({
        store: store,
        offset: 0,
        lastDateTime: last
      });
    },

    async createAppointment(context, appointment) {
      if (appointment.isDirty === true) {
        const store = this;
        try {
          let response = await axios({
            method: "post",
            url: API_BASE_URL + `/appointment`,
            data: {
              accountId: appointment.accountId,
              customerId:
                appointment.customerId > 0 ? appointment.customerId : null,
              jobTypeId:
                appointment.jobTypeId > 0 ? appointment.jobTypeId : null,
              addressId:
                appointment.addressId > 0 ? appointment.addressId : null,
              contactInfoId:
                appointment.contactInfoId > 0
                  ? appointment.contactInfoId
                  : null,
              serviceEmployeeId:
                appointment.serviceEmployeeId > 0
                  ? appointment.serviceEmployeeId
                  : null,
              note: appointment.note,
              startTime: appointment.startTime,
              endTime: appointment.endTime
            },
            headers: {
              Authorization: `Bearer ${localStorage.getItem("access_token")}`
            }
          });
          store.dispatch("entities/appointments/delete", {
            where: appointment.tempId
          });
          store.dispatch("entities/appointments/insert", {
            where: response.id,
            data: response.data
          });
          store.dispatch("entities/settings/setIsOffline", false);
        } catch (error) {
          store.dispatch("entities/settings/setIsOffline", true);
        }
      }
    },
    async updateAppointment(context, appointment) {
      if (appointment.isDirty === true) {
        const store = this;
        try {
          let response = await axios({
            method: "patch",
            url: API_BASE_URL + `/appointment/${appointment.id}`,
            data: {
              accountId: appointment.accountId,
              id: appointment.id,
              customerId:
                appointment.customerId > 0 ? appointment.customerId : null,
              jobTypeId:
                appointment.jobTypeId > 0 ? appointment.jobTypeId : null,
              addressId:
                appointment.addressId > 0 ? appointment.addressId : null,
              contactInfoId:
                appointment.contactInfoId > 0
                  ? appointment.contactInfoId
                  : null,
              serviceEmployeeId:
                appointment.serviceEmployeeId > 0
                  ? appointment.serviceEmployeeId
                  : null,
              note: appointment.note,
              startTime: appointment.startTime,
              endTime: appointment.endTime,
              travelStartTime: appointment.travelStartTime
            },
            headers: {
              Authorization: `Bearer ${localStorage.getItem("access_token")}`
            }
          });
          store.dispatch("entities/appointments/update", {
            where: response.id,
            data: response.data
          });
          store.dispatch("entities/settings/setIsOffline", false);
        } catch (error) {
          store.dispatch("entities/settings/setIsOffline", true);
        }
      }
    },
    async deleteAppointment(context, appointment) {
      const store = this;
      store.dispatch("entities/appointments/delete", appointment.id);

      if (appointment.isDirty === true) {
        try {
          await axios({
            method: "patch",
            url: API_BASE_URL + `/appointment/${appointment.id}`,
            data: {
              accountId: appointment.accountId,
              id: appointment.id,
              deleted: true
            },
            headers: {
              Authorization: `Bearer ${localStorage.getItem("access_token")}`
            }
          });
          store.dispatch("entities/settings/setIsOffline", false);
        } catch (error) {
          store.dispatch("entities/settings/setIsOffline", true);
        }
      }
    }
  }
};

async function fetchNext({ store, offset, resolve, reject, lastDateTime = 0 }) {
  try {
    let response = await axios({
      method: "get",
      url:
        API_BASE_URL +
        `/appointment?updatedAt[$gt]=${lastDateTime}&$limit=${FETCH_LIMIT}&$skip=${offset}`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("access_token")}`
      }
    });
    const obj = response.data.data;
    const maxRows = response.data.total;
    let appointments = [];
    obj.forEach(function(appointment) {
      appointments.push({
        id: appointment.id,
        isDirty: false,
        accountId: appointment.accountId,
        customerId: appointment.customerId,
        jobTypeId: appointment.jobTypeId,
        addressId: appointment.addressId,
        contactInfoId: appointment.contactInfoId,
        serviceEmployeeId: appointment.serviceEmployeeId,
        note: appointment.note,
        startTime: Date.parse(appointment.startTime),
        endTime: Date.parse(appointment.endTime),
        travelStartTime: Date.parse(appointment.travelStartTime),
        createdAt: Date.parse(appointment.createdAt),
        updatedAt: Date.parse(appointment.updatedAt)
      });
    });
    if (appointments.length > 0) {
      store.dispatch("entities/appointments/insert", {
        data: appointments
      });
    }
    store.dispatch("entities/settings/setIsOffline", false);
    if (maxRows > FETCH_LIMIT + offset) {
      await fetchNext({
        store,
        offset: FETCH_LIMIT + offset,
        resolve,
        reject,
        lastDateTime
      });
    } else {
      await resolve();
    }
  } catch (error) {
    store.dispatch("entities/settings/setIsOffline", true);
    await resolve();
  }
}
